m = require 'mithril'

CommonViews = require './CommonViews'

DeleteButton = {
	controller: (args) ->
		showPopup = m.prop false
		{
			showPopup
			firstClick: () -> showPopup true
			dismissClick: () -> showPopup false
			confirmClick: (e) ->
				showPopup false
				args.onclick e
		}
		
	view: (ctrl, args) ->
		showPopup = ctrl.showPopup()
		m '.deletebutton', [
			m 'p.deletebutton__message', args.message unless showPopup
			m 'p.deletebutton__confirmation', 'Are you sure?  This action can not be undone.' if showPopup
			m 'button.deletebutton__button[type=button]', {
				onclick: if showPopup then ctrl.confirmClick else ctrl.firstClick
			}, [
				CommonViews.icon CommonViews.icons.bin, 'deletebutton__buttonicon'
				args.label
			]
			m 'span.deletebutton__cancel', {onclick: ctrl.dismissClick}, 'Cancel' if showPopup
		]
}

module.exports = DeleteButton